import {
  hrModuleArray,
  dprModuleArray,
  adminModuleArray,
  rulesModuleArray,
  accessModuleArray,
  accountModuleArray,
  registerModuleArray,
  attendanceModuleArray,
  superAdminModuleArray
} from "./navData";

const leftNaveRender = (module) => {
  switch (module) {
    case "ADMIN MODULE":
      return adminModuleArray;
    case "ATTENDANCE MODULE":
      return attendanceModuleArray;
    case "REGISTER MODULE":
      return registerModuleArray;
    case "RULES MODULE":
      return rulesModuleArray;
    case "ACCOUNTS MODULE":
      return accountModuleArray;
    case "ACCESS MODULE":
      return accessModuleArray;
    case "DPR MODULE":
      return dprModuleArray;
    case "HR MODULE":
      return [
        ...registerModuleArray,
        ...attendanceModuleArray,
        ...hrModuleArray,
        ...dprModuleArray
      ];
    default:
      // return accessModuleArray;
      return superAdminModuleArray;
  }
};

export { leftNaveRender };
